var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('commonAnnouncementDetail',{attrs:{"pageData":_vm.pageData,"currBreadCrumb":_vm.currBreadCrumb,"fileData":_vm.fileData}})}
var staticRenderFns = []

export { render, staticRenderFns }